import banner from "./banner.jpg"
import logo from "./logo.jpg"

const shop = {
    id: "shop007",
  
    vendorId: "z8zffHwBcXVojo5cCbWeK6gHqVO2",
  
    slug: "the-place",
  
    name: "The Place",
  
    category: "food",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "medium",

    products: [],

    location: "Abuja",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;